import { createContext } from "react";

const VisualizeContext = createContext({
    ChartCategories:[]
});

export default VisualizeContext;